/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskListItemStatus = typeof TaskListItemStatus[keyof typeof TaskListItemStatus];


export const TaskListItemStatus = {
  pending: 'pending',
  scheduled: 'scheduled',
  executing: 'executing',
  done: 'done',
  archived: 'archived',
  failed: 'failed',
} as const;
